<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">This important book illustrating Orlando’s evolution as a diverse and notable city would not exist without the gracious assistance and professionalism of the following librarians, research historians, educators, academics, archivists, assistants, and history lovers: Dixon Gutierrez, State Archives and Library of Florida; Katelyn Herring-Saltzberg, State Archives and Library of Florida; Melissa Procko, Orange County Regional History Center; Pamela Schwartz, Orange County Regional History Center &amp; Historical Society of Central Florida; Todd L. Bothel, Jewish Museum of Florida-FIU; Heather Bonds, Historic Preservation Board, City of Orlando; Wenxian Zhang, Olin Library- Rollins College; Alyssa Windsor, Olin Library-Rollins College; David Benjamin and staff, Special Collections &amp; University Archives Libraries, University of Central Florida;Tomaro Taylor, University of South Florida (USF) Libraries Special Collections; Kim Peters, Orlando Public Library; Tim Orwick, Orlando Memory; Stephen Herring, <i>Orlando Retro;</i> Walter Hawkins, Jones High School Historical Society; Katrece Pitts, Wells’Built Museum of African American History and Culture; David Matteson and David Bain, LGBTQ History Museum of Central Florida; HuntonBrady Architects; Karen Hart, Linda’s LaCantina; Karick A. Price Jr., Price Collins Motors; Sandra Worden Pickett; Denise and Steven Allen; Ron Jaffe; and Grace A. Chewning, Orlando city clerk emeritus. I would like to express my heartfelt appreciation to all of the above individuals, and to the institutions, memories, and societies they represent.</p>
<p class="para">Unless otherwise noted, all present images were photographed by Bob Randall.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?fd866164